<template>
  <div class="task">
    <el-row class="header-row">
      <span class="idBox">{{ editForm.task_id }}</span>
      <span>{{ editForm.task_name }}</span>
      <span class="roleBtn" v-for="(item, index) in roleList" :key="index">
        <el-button v-if="
          item === '/allTask/developmentStart' && editForm.task_status == 0
        " type="text" @click="changeStatus(1)">开始开发</el-button>
        <el-button v-if="editForm.task_status == 1 && item === '/allTask/submitTest'" type="text"
          @click="changeStatus(2)">提交测试</el-button>
        <el-button v-if="editForm.task_status == 3 && item === '/allTask/startTesting'" type="text"
          @click="changeStatus(3)">开始测试</el-button>
        <el-button v-if="
          (editForm.task_status == 1 || editForm.task_status == 4) &&
          item === '/allTask/stop'
        " type="text" @click="stopDialog(2)">暂停</el-button>
        <el-button v-if="
          (editForm.task_status === 2 || editForm.task_status === 5) &&
          item === '/allTask/continue'
        " type="text" @click="changeStatus(5)">继续</el-button>
        <el-button v-if="editForm.task_status == 4 && item === '/allTask/finishedTest'" type="text"
          @click="changeStatus(6)">测试完成</el-button>
        <el-button v-if="item === '/allTask/discardTask'" type="text" @click="stopDialog(1)">废弃</el-button>
        <el-button v-if="
          (showWorkTimebtn('testTime', editForm)) &&
          item === '/allTask/testRecordingHours'
        " type="text" @click="editDialog(1)">测试记录工时</el-button>
        <el-button v-if="
          (showWorkTimebtn('coderTime', editForm)) &&
          item === '/allTask/developmentRecordingHours'
        " type="text" @click="editDialog(0)">开发记录工时</el-button>
        <el-button v-if="
          (showWorkTimebtn('testEditTime', editForm)) &&
          item === '/allTask/testEditHours'
        " type="text" @click="editHour(1)">测试编辑工时</el-button>
        <el-button v-if="
          (showWorkTimebtn('coderEditTime', editForm)) &&
          item === '/allTask/developmentEditHours'
        " type="text" @click="editHour(0)">开发编辑工时</el-button>
        <el-button v-if="item === '/allTask/editTask'" type="text" @click="
          $router.push({
            path: '/allTask/editTask',
            query: { task_id: editForm.task_id },
          })
          ">编辑</el-button>
      </span>
    </el-row>
    <el-row>
      <!--左-->
      <el-col class="left-container" :span="19">
        <h5>任务描述</h5>
        <el-row class="left-item" id="remark">
          <div>
            <el-input v-html="editForm.task_remark" type="textarea"></el-input>
          </div>
        </el-row>
        <h5>需求描述</h5>
        <el-row class="left-item el-tiptap-editor__content" id="remark" v-viewer>
          <div v-html="editForm.demand_remark" type="textarea">
          </div>
        </el-row>
        <h5>任务附件</h5>
        <el-row class="left-item" id="remark">
          <div>
            <el-upload :action="actionUrl" :file-list="fileList" :on-preview="downFile" accept="*" class="upload-demo"
              multiple :disabled="check"></el-upload>
          </div>
        </el-row>
        <h5>需求附件</h5>
        <el-row class="left-item" id="remark">
          <div>
            <el-upload :action="actionUrl" :file-list="fileList1" :on-preview="downFile" accept="*" class="upload-demo"
              multiple :disabled="check"></el-upload>
          </div>
        </el-row>
        <h5>留言</h5>
        <el-row class="left-item" id="remark">
          <div v-viewer>
            <el-input v-html="editForm.task_note" type="textarea"></el-input>
          </div>
        </el-row>
        <el-row style="margin-bottom: 20px">
          <div>
            <el-table :data="defectList" style="width: 100%; border: 1px solid rgb(198, 226, 255)">
              <el-table-column label="缺陷编号" width="100" prop="tb_id"></el-table-column>
              <el-table-column show-overflow-tooltip label="缺陷标题" align="center">
                <template slot-scope="scope">
                  <el-tooltip v-if="scope.row.defect_type === 18" effect="dark" :content="'不是缺陷'" placement="top">
                    <svg-icon icon-class="notbug" class="notbug" />
                  </el-tooltip>
                  <router-link :to="{
                    name: 'lookDefect',
                    params: { tb_id: scope.row.tb_id },
                  }">{{ scope.row.tb_name }}</router-link>
                </template>
              </el-table-column>
              <el-table-column width="150" prop="tb_status" label="缺陷状态"></el-table-column>
              <el-table-column width="150" prop="tb_next_user_name" label="缺陷当前处理人"></el-table-column>
              <el-table-column width="150" prop="tb_coding_user_name" label="开发"></el-table-column>
              <el-table-column width="150" prop="tb_test_user_name" label="测试"></el-table-column>
            </el-table>
          </div>
        </el-row>
        <el-row style="margin-bottom: 20px">
          <el-button type="text" @click="remarkBtn = !remarkBtn">添加备注</el-button>
        </el-row>
        <el-row class="left-item" v-if="remarkBtn">
          <el-form :model="addRemark" class="demo-form-inline">
            <el-form-item>
              <TipTapEditor v-if="remarkBtn" v-model="addRemark.remark" />
              <!-- <Wangeditor v-if="remarkBtn" v-model="addRemark.remark" @change="decChange" /> -->
            </el-form-item>
            <el-button type="primary" @click="Submit">提交</el-button>
          </el-form>
        </el-row>
        <h5>历史记录</h5>
        <el-row class="left-item" id="remark">
          <div>
            <!-- 历史记录 -->
            <div class="historyRecord">
              <div class="header">
                <!-- <span class="left">历史记录</span>
                <span class="iconBox" icon="el-icon-plus"/>
                <i class="dividingLine"/>-->
              </div>
              <div class="content" v-viewer>
                <el-collapse>
                  <el-collapse-item v-for="(item, index1) of historyList" :key="index1" :title="`${item.dl_create_date}，由${item.dl_creater_name ? item.dl_creater_name : ''
                    } ${item.dl_type_name ? item.dl_type_name : '修改'} `" :name="index1">
                    <div v-if="
                      typeof item.dl_remark === 'string'
                    ">
                      <!-- 添加了备注 -->
                      <el-row>
                        <span v-html="item.dl_remark"></span>
                      </el-row>
                    </div>
                    <div v-if="
                      typeof item.dl_remark === 'object' &&
                      item.dl_remark !== null
                    ">
                      <el-row v-if="item.dl_remark.modify.old.project_name">
                        修改了
                        <span class="collapseLabel">所属产品</span>，旧值为
                        <span>"{{ item.dl_remark.modify.old.project_name }}"</span>，新值为
                        <span>"{{ item.dl_remark.modify.new.project_name }}"</span>
                      </el-row>
                      <el-row v-if="item.dl_remark.modify.new.pm_name">
                        修改了
                        <span class="collapseLabel">所属模块</span>，旧值为
                        <span>"{{ item.dl_remark.modify.old.pm_name }}"</span>，新值为
                        <span>"{{ item.dl_remark.modify.new.pm_name }}"</span>
                      </el-row>
                      <el-row v-if="item.dl_remark.modify.new.task_level_name">
                        修改了
                        <span class="collapseLabel">优先级</span>，旧值为
                        <span>"{{
                          item.dl_remark.modify.old.task_level_name
                        }}"</span>，新值为
                        <span>"{{
                          item.dl_remark.modify.new.task_level_name
                        }}"</span>
                      </el-row>
                      <el-row v-if="item.dl_remark.modify.new.task_next_user_name">
                        修改了
                        <span class="collapseLabel">下一处理人</span>，旧值为
                        <span>"{{
                          item.dl_remark.modify.old.task_next_user_name
                        }}"</span>，新值为
                        <span>"{{
                          item.dl_remark.modify.new.task_next_user_name
                        }}"</span>
                      </el-row>
                      <el-row v-if="item.dl_remark.modify.new.demand_name">
                        修改了
                        <span class="collapseLabel">相关需求</span>，旧值为
                        <span>"{{ item.dl_remark.modify.old.demand_name }}"</span>，新值为
                        <span>"{{ item.dl_remark.modify.new.demand_name }}"</span>
                      </el-row>
                      <el-row v-if="item.dl_remark.modify.new.task_name">
                        修改了
                        <span class="collapseLabel">任务标题</span>，旧值为
                        <span>"{{ item.dl_remark.modify.old.task_name }}"</span>，新值为
                        <span>"{{ item.dl_remark.modify.new.task_name }}"</span>
                      </el-row>
                      <el-row v-if="item.dl_remark.modify.new.task_remark" :gutter="20" class="historyBox">
                        <el-col :span="2" class="label">任务描述</el-col>
                        <el-col :span="10" class="old" v-html="item.dl_remark.modify.old.task_remark" />
                        <el-col :span="1" class="label">=></el-col>
                        <el-col :span="10" class="new" v-html="item.dl_remark.modify.new.task_remark" />
                      </el-row>
                      <el-row v-if="item.dl_remark.modify.new.task_status">
                        修改了
                        <span class="collapseLabel">任务状态</span>，旧值为
                        <span>"{{ item.dl_remark.modify.old.task_status }}"</span>，新值为
                        <span>"{{ item.dl_remark.modify.new.task_status }}"</span>
                        <span v-if="item.dl_remark.modify.new.reason">, 原因：
                          {{ item.dl_remark.modify.new.reason }}，</span>
                        <span v-if="item.dl_remark.modify.new.note">原因备注：
                          {{ item.dl_remark.modify.new.note }}</span>
                      </el-row>
                      <el-row v-if="item.dl_remark.modify.new.demand_status">
                        修改了
                        <span class="collapseLabel">需求状态</span>，旧值为
                        <span>"{{ item.dl_remark.modify.old.demand_status }}"</span>，新值为
                        <span>"{{ item.dl_remark.modify.new.demand_status }}"</span>
                      </el-row>
                      <el-row v-if="item.dl_remark.modify.new.task_coding_user_name">
                        修改了
                        <span class="collapseLabel">开发负责人</span>，旧值为
                        <span>"{{
                          item.dl_remark.modify.old.task_coding_user_name
                        }}"</span>，新值为
                        <span>"{{
                          item.dl_remark.modify.new.task_coding_user_name
                        }}"</span>
                      </el-row>
                      <el-row v-if="item.dl_remark.modify.new.task_plan_start_date">
                        修改了
                        <span class="collapseLabel">计划开发开始时间</span>，旧值为
                        <span>"{{
                          item.dl_remark.modify.old.task_plan_start_date
                        }}"</span>，新值为
                        <span>"{{
                          item.dl_remark.modify.new.task_plan_start_date
                        }}"</span>
                      </el-row>
                      <el-row v-if="item.dl_remark.modify.new.task_plan_complete_date">
                        修改了
                        <span class="collapseLabel">计划开发完成时间</span>，旧值为
                        <span>"{{
                          item.dl_remark.modify.old.task_plan_complete_date
                        }}"</span>，新值为
                        <span>"{{
                          item.dl_remark.modify.new.task_plan_complete_date
                        }}"</span>
                      </el-row>
                      <el-row v-if="item.dl_remark.modify.new.task_coding_time">
                        修改了
                        <span class="collapseLabel">预计开发工时</span>，旧值为
                        <span>"{{
                          item.dl_remark.modify.old.task_coding_time
                        }}"</span>，新值为
                        <span>"{{
                          item.dl_remark.modify.new.task_coding_time
                        }}"</span>
                      </el-row>
                      <el-row v-if="item.dl_remark.modify.new.task_test_user_name">
                        修改了
                        <span class="collapseLabel">测试人</span>，旧值为
                        <span>"{{
                          item.dl_remark.modify.old.task_test_user_name
                        }}"</span>，新值为
                        <span>"{{
                          item.dl_remark.modify.new.task_test_user_name
                        }}"</span>
                      </el-row>
                      <el-row v-if="item.dl_remark.modify.new.task_test_time">
                        修改了
                        <span class="collapseLabel">预计测试工时</span>，旧值为
                        <span>"{{
                          item.dl_remark.modify.old.task_test_time
                        }}"</span>，新值为
                        <span>"{{
                          item.dl_remark.modify.new.task_test_time
                        }}"</span>
                      </el-row>
                      <el-row v-if="item.dl_remark.modify.new.task_attachment">
                        修改了
                        <span class="collapseLabel">上传文件</span>，旧值为
                        <span>"{{
                          item.dl_remark.modify.old.task_attachment
                        }}"</span>，新值为
                        <span>"{{
                          item.dl_remark.modify.new.task_attachment
                        }}"</span>
                      </el-row>
                      <el-row v-if="item.dl_remark.modify.new.tb_name">
                        修改了
                        <span class="collapseLabel">缺陷标题</span>，旧值为
                        <span>"{{ item.dl_remark.modify.old.tb_name }}"</span>，新值为
                        <span>"{{ item.dl_remark.modify.new.tb_name }}"</span>
                      </el-row>
                      <el-row v-if="item.dl_remark.modify.new.note">
                        修改了
                        <span class="collapseLabel">备注</span>，旧值为
                        <span>"{{ item.dl_remark.modify.old.note }}"</span>，新值为
                        <span>"{{ item.dl_remark.modify.new.note }}"</span>
                        <span v-if="item.dl_remark.info"></span>
                      </el-row>
                      <el-row v-if="item.dl_remark.modify.new.tb_remark" :gutter="20" class="historyBox">
                        <!-- <span class="collapseLabel">缺陷描述</span>，旧值为
                <span>"{{ item.dl_remark.modify.old.tb_remark }}"</span>，新值为
                        <span>"{{ item.dl_remark.modify.new.tb_remark }}"</span>-->
                        <el-col :span="2" class="label">缺陷描述</el-col>
                        <el-col :span="10" class="old" v-html="item.dl_remark.modify.old.tb_remark" />
                        <el-col :span="1" class="label">=></el-col>
                        <el-col :span="10" class="new" v-html="item.dl_remark.modify.new.tb_remark" />
                      </el-row>
                      <el-row v-if="item.dl_remark.modify.new.task_note" :gutter="20" class="historyBox">
                        <el-col :span="2" class="label">留言</el-col>
                        <el-col :span="10" class="old" v-html="item.dl_remark.modify.old.task_note" />
                        <el-col :span="1" class="label">=></el-col>
                        <el-col :span="10" class="new" v-html="item.dl_remark.modify.new.task_note" />
                      </el-row>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
            </div>
          </div>
        </el-row>

        <el-button type="success" @click="$router.push('/allDemands/index')">返回</el-button>
      </el-col>
      <!--右-->
      <el-col class="right-container" :span="5">
        <h5>基本信息</h5>
        <el-row class="right-item" id="remark">
          <el-row>
            <el-col :span="8">所属产品</el-col>
            <el-col :span="16">{{ editForm.project_name }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="8">所属模块</el-col>
            <el-col :span="16">{{ editForm.pm_name }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="8">优先级</el-col>
            <el-col :span="16">{{ editForm.task_level_name }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="8">创建人</el-col>
            <el-col :span="16">{{ editForm.task_creater_name }} 于
              {{ editForm.task_create_date }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="8">当前处理人</el-col>
            <el-col :span="16" v-if="editForm.task_status !== 6">{{
              editForm.task_next_user_name
            }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="8">状态</el-col>
            <el-col :span="16">{{ editForm.task_status_name }}</el-col>
          </el-row>
          <el-row class="demandTitle">
            <el-col :span="8">相关需求</el-col>
            <template>
              <router-link v-if="editForm.demand_id" :to="{
                path: '/allDemand/newCheckDemand',
                query: { demand_id: editForm.demand_id },
              }" target="_blank" style="color: blue">
                <el-col :span="16" style="word-break: break-all;">#{{ editForm.demand_id }}==：{{ editForm.demand_name
                }}</el-col>
              </router-link>
            </template>
          </el-row>
          <el-row class="demandTitle" style="margin-top: 10px;">
            <span class="right-item-span">关联需求</span>
            <template v-if="editForm.demand_relation && editForm.demand_relation.length > 0">
              <el-row v-for="item in editForm.demand_relation" :key="item.demand_id" class="right-item-link">
                <router-link v-if="item.demand_id" :to="{
                  path: '/allDemand/newCheckDemand',
                  query: { demand_id: item.demand_id },
                }" target="_blank" style="color: blue">
                  <!-- <el-col :span="6">#{{ item.demand_id }}==：</el-col> -->
                  <el-col :span="24" :title="item.demand_name" style="word-break: break-all;">#{{ item.demand_id }}==：{{
                    item.demand_name }}</el-col>
                </router-link>
              </el-row>
            </template>

          </el-row>
        </el-row>
        <h5>工时信息</h5>
        <el-row class="right-item" id="remark">
          <el-row>
            <el-col :span="8">计划开发时间</el-col>
            <el-col :span="16">{{ editForm.task_plan_start_date }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="8">计划完成时间</el-col>
            <el-col :span="16">{{ editForm.task_plan_complete_date }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="8">程序员</el-col>
            <el-col :span="16">{{ editForm.task_coding_user_name }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="8">预计开发工时</el-col>
            <el-col :span="16">
              {{ editForm.task_coding_time }}
              <span>&nbsp; H</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">开发实际工时</el-col>
            <el-col :span="16">
              {{ editForm.coding_practical_time }}
              <span>&nbsp; H</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">测试人</el-col>
            <el-col :span="16">{{ editForm.task_test_user_name }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="8">预计测试工时</el-col>
            <el-col :span="16">
              {{ editForm.task_test_time?editForm.task_test_time.toFixed(1):'' }}
              <span>&nbsp; H</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">测试实际工时</el-col>
            <el-col :span="16">
              {{ editForm.test_practical_time?editForm.test_practical_time.toFixed(1):'' }}
              <span>&nbsp; H</span>
            </el-col>
          </el-row>
        </el-row>
      </el-col>
      <stop-dialog :visible="stopVisibel" @cancel="stopVisibel = false" @submitStop="submitStop" :typeId="typeId"
        :lastTask="lastTask"></stop-dialog>
      <hours-dialog :visible="WorkingHours" :typeIds="typeIds" @resetForm="WorkingHours = false" ref="hoursDialog"
        @submitForm="submitForm"></hours-dialog>
      <edit-hours-dailog :visible="editHours" :typesId="typesId" @cancelEdit="cancelEdit" @deleteHours="deleteHours"
        @editHoursData="editHoursData" @submitHoursData="submitHoursData" ref="mychild"></edit-hours-dailog>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Tinymce from '@/components/Tinymce'
// import Wangeditor from '@/components/Wangeditor'
import { deepClone } from '@/utils/index'
import { getCheckTask, getTaskLog } from '@/api/editTask'
import {
  getUserInfoByName,
  getUserInfoById,
  getUserInfoByIdList
} from '@/api/login'
import {
  updateStatus,
  listBtn,
  recordHours,
  editHoursList
} from '@/api/allTask'
import { getModel, getProjectList, submitRemark, taskisDiscard } from '@/api/demand'
import { uploadImg } from '@/api/upload'
import axios from 'axios'
import { getDemand } from '@/api/rejectTask'
import stopDialog from '../../component/stopDialog'
import hoursDialog from '../../component/hoursDialog'
import editHoursDailog from '../../component/editHoursDailog'
import { localStorageFn } from '@/utils'
export default {
  name: 'TinymceDemo',
  components: {
    Tinymce,
    stopDialog,
    hoursDialog,
    editHoursDailog
  },
  data() {
    return {
      lastTask: false, // 是否是废弃的最后一个任务
      editHours: false,
      hoursData: false,
      WorkingHours: false,
      stopVisibel: false,
      switchs: false,
      typeId: '',
      typeIds: '',
      typesId: '',
      check: true,
      projectList: [],
      stopForm: {},
      modleList: [],
      oldModleList: [],
      demandList: [],
      oldDemandList: [],
      roleList: [],
      projectId: [],
      pmId: [],
      demandId: [],
      selectLoading: false,
      codingProposerList: [], // 开发负责人
      nextProcessorList: [], // 下一处理人
      testList: [], // 测试人
      makeCopyList: [], // 抄送给
      defectList: [], // 缺陷列表
      historyList: [],
      editForm: {
        demand_id: ''
      },
      remarkBtn: false,
      addRemark: {
        remark: '' // :"", 内容
      },
      fileList: [],
      fileList1: [],
      oldEditForm: {},
      pv_status: '',
      role: {},
      creater: [],
      actionUrl: process.env.VUE_APP_BASE_API + '/api/common/upload'
    }
  },
  computed: {
    ...mapGetters(['size', 'userId', 'urlInfo'])
  },
  mounted() {
    this.getList()
    this.getTasklogList()
  },
  methods: {
    stopDialog(typeId) {
      if (typeId === 1) {
        const obj = {
          task_id: [this.editForm.task_id]
        }
        taskisDiscard(obj).then(res => {
          if (res.data.is_discard === 0) {
            this.stopVisibel = true
            this.typeId = typeId
            this.lastTask = false
          } else {
            this.$confirm('废弃此任务会同时废弃需求，是否同意？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.stopVisibel = true
              this.typeId = typeId
              this.lastTask = true
            }).catch(() => {
              this.lastTask = false
              this.$message({
                type: 'info',
                message: '已取消废弃'
              })
            })
          }
        })
      } else {
        this.stopVisibel = true
        this.typeId = typeId
      }

    },
    editDialog(typeIds) {
      this.WorkingHours = true
      this.typeIds = typeIds
    },
    editHour(typesId) {
      this.editHours = true
      this.typesId = typesId
    },
    cancelEdit() {
      this.editHours = false
    },
    editHoursData() {
      this.hoursData = true
    },
    submitHoursData(params) {
      editHoursList(params)
        .then((response) => {
          this.$message({
            message: '编辑工时成功~',
            type: 'success'
          })
          this.hoursData = false
          this.$refs.mychild.closeLoading()
          this.$refs.mychild.editHoursList()
        })
        .catch((error) => {
          console.log(error)
          this.$refs.mychild.closeLoading()
        })
    },
    deleteHours(delParams) {
      editHoursList(delParams)
        .then((response) => {
          this.$message({
            message: '删除工时成功~',
            type: 'success'
          })
          this.$refs.mychild.editHoursList()
          this.getList()
        })
        .catch((error) => {
          console.log(error)
        })
    },
    submitForm(params) {
      recordHours(params)
        .then((response) => {
          this.WorkingHours = false
          this.$message({
            message: '记录工时成功~',
            type: 'success'
          })
          this.$refs.hoursDialog.closeLoading()
          this.getList()
        })
        .catch((error) => {
          this.WorkingHours = false
          this.$refs.hoursDialog.closeLoading()
          console.log(error)
        })
    },
    changeStatus(statusId) {
      if (statusId === 1) {
        this.statusTxt = '开始开发'
      } else if (statusId === 2) {
        this.statusTxt = '提交测试'
      } else if (statusId === 3) {
        this.statusTxt = '开始测试'
      } else if (statusId === 4) {
        this.statusTxt = '暂停'
      } else if (statusId === 5) {
        this.statusTxt = '继续'
      } else if (statusId === 6) {
        this.statusTxt = '测试完成'
      }
      this.taskIdList = []
      this.taskIdList.push(this.editForm.task_id)
      this.$confirm(`是否${this.statusTxt}`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const params = {
            user_id: this.userId,
            task_id: this.taskIdList,
            status: statusId
          }
          listBtn(params)
            .then((response) => {
              this.$message({
                type: 'success',
                message: `已${this.statusTxt}!`
              })
              this.getList()
            })
            .catch((error) => {
              console.log(error)
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: `已取消${this.statusTxt}!`
          })
        })
    },
    submitStop(form) {
      console.log(form)
      updateStatus(form)
        .then((response) => {
          // console.log(response.data);
          this.getList()
          this.$message({
            message: '提交成功',
            type: 'success'
          })
          this.stopVisibel = false
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getList() {
      this.roleList = []
      this.pv_status = this.$route.query.pv_status
      // 获取角色
      const urlList = this.$store.getters.actionUrl
      for (let i = 0; i < urlList.length; i++) {
        this.roleList.push(urlList[i].url)
      }

      // 获取产品
      getProjectList(this.userId)
        .then((response) => {
          this.projectList = response.data.projectIds
          response.data.projectIds.map((item) => {
            if (item.project_id === this.editForm.project_id) {
              this.$set(this.editForm, 'project_name', item.project_name)
            }
          })
        })
        .catch((error) => {
          console.log(error)
        })
      // 获取任务详情
      getCheckTask(this.$route.query.task_id)
        .then((response) => {
          const defect_list = response.data.task_bug
          console.log(333, defect_list);

          const useridList = []
          for (let i = 0; i < defect_list.length; i++) {
            ['tb_next_user', 'tb_coding_user', 'tb_test_user'].forEach((sKey) => {
              const sKeyValue = localStorageFn(defect_list[i][sKey], 2);
              if (sKeyValue) {
                defect_list[i][sKey + '_name'] = sKeyValue.name
                defect_list[i][sKey + '_username'] = sKeyValue.username
              } else {
                useridList.push(defect_list[i][sKey])
              }
              console.log(999, sKey, sKeyValue);

            });
          }

          const p1 = getUserInfoByIdList({
            userIds: useridList
          }).then((res) => {
            const userData = res.data
            for (const i in defect_list) {
              ['tb_next_user', 'tb_coding_user', 'tb_test_user'].forEach((sKey) => {
                if (!defect_list[i][sKey + '_name']) {
                  const tempItem = userData.find((item) => {
                    return item.userId == defect_list[i][sKey]
                  })
                  defect_list[i][sKey + '_name'] = tempItem.name
                  defect_list[i][sKey + '_username'] = tempItem.username
                  localStorageFn(defect_list[i][sKey], 1, tempItem);
                }
              });
            }
          })
          if (useridList.length > 0) {
            Promise.all([p1])
              .then(() => {
                this.defectList = defect_list
              })
              .catch(() => {
                this.$message({
                  message: '获取用户信息失败!',
                  type: 'error'
                })
              })
          } else {
            this.defectList = defect_list
          }

          const responseData = response.data.task_edit
          // 定义一个旧值先保存起来，用户改变新值之后与之对比，把修改过的值发送给后台 modify
          this.oldEditForm = deepClone(responseData[0])
          responseData[0].dev_lead = responseData[0].demand_dev_lead
          this.editForm = response.data.task_edit[0]

          this.editForm.task_remark = response.data.task_edit[0].task_remark
          this.editForm.demand_remark = response.data.task_edit[0].demand_remark

          // 优先级名字
          switch (this.editForm.task_level) {
            case 0:
              this.$set(this.editForm, 'task_level_name', '低')
              break
            case 1:
              this.$set(this.editForm, 'task_level_name', '中')
              break
            case 2:
              this.$set(this.editForm, 'task_level_name', '高')
              break
            case 3:
              this.$set(this.editForm, 'task_level_name', '特别高')
              break
            default:
              this.$set(this.editForm, 'task_level_name', '中')
              break
          }
          // 状态名字
          switch (this.editForm.task_status) {
            case 0:
              this.$set(this.editForm, 'task_status_name', '待开发')
              break
            case 1:
              this.$set(this.editForm, 'task_status_name', '开发中')
              break
            case 2:
              this.$set(this.editForm, 'task_status_name', '开发暂停')
              break
            case 3:
              this.$set(this.editForm, 'task_status_name', '待测试')
              break
            case 4:
              this.$set(this.editForm, 'task_status_name', '测试中')
              break
            case 5:
              this.$set(this.editForm, 'task_status_name', '测试暂停')
              break
            case 6:
              this.$set(this.editForm, 'task_status_name', '测试完成')
              break
            case 7:
              this.$set(this.editForm, 'task_status_name', '废弃')
              break
          }
          // 使用正则表达式给需求描述的img标签增加宽度100%
          if (this.editForm.demand_remark != null) {
            this.editForm.demand_remark = this.imgTagAddStyle(
              this.editForm.demand_remark
            )
            this.formatDemandRemark()
            this.formatCodeBlock()
          }
          if (
            this.editForm.task_remark != null ||
            this.editForm.task_remark !== ''
          ) {
            // 任务描述
            this.editForm.task_remark = this.imgTagAddStyle(
              this.editForm.task_remark
            )
          }
          // 显示文件列表
          const getData = JSON.parse(
            JSON.stringify(response.data.task_edit[0])
          )
          this.fileList = []
          if (getData.task_attachment) {
            this.editForm.task_attachment =
              response.data.task_edit[0].task_attachment
            for (let i = 0; i < getData.task_attachment.length; i++) {
              const obj = {}
              obj.name = getData.task_attachment[i]
              obj.url = getData.task_attachment[i]
              this.fileList.push(obj)
            }
          } else {
            this.editForm.task_attachment = []
          }
          // 需求附件
          const getData1 = JSON.parse(
            JSON.stringify(response.data.task_edit[0])
          )
          this.fileList1 = []
          if (getData1.demand_attachment) {
            this.editForm.demand_attachment =
              response.data.task_edit[0].demand_attachment
            for (let i = 0; i < getData1.demand_attachment.length; i++) {
              const obj = {}
              obj.name = getData1.demand_attachment[i]
              obj.url = getData1.demand_attachment[i]
              this.fileList1.push(obj)
            }
          } else {
            this.editForm.demand_attachment = []
          }
          // 显示文件列表
          // 开发负责人
          if (responseData[0].task_coding_user) {
            getUserInfoById(responseData[0].task_coding_user)
              .then((res) => {
                this.codingProposerList.push(res.data)
                this.$set(
                  this.editForm,
                  'task_coding_user_name',
                  res.data.name
                )
              })
              .catch(() => { })
          }
          if (responseData[0].task_creater) {
            getUserInfoById(responseData[0].task_creater)
              .then((res) => {
                this.creater.push(res.data)
                this.$set(this.editForm, 'task_creater_name', res.data.name)
              })
              .catch(() => { })
          }
          // 当前处理人
          if (responseData[0].task_next_user) {
            getUserInfoById(responseData[0].task_next_user)
              .then((res) => {
                this.nextProcessorList.push(res.data)
                this.$set(this.editForm, 'task_next_user_name', res.data.name)
              })
              .catch(() => { })
          }
          // 测试人
          if (responseData[0].task_test_user) {
            getUserInfoById(responseData[0].task_test_user)
              .then((res) => {
                this.testList.push(res.data)
                this.$set(this.editForm, 'task_test_user_name', res.data.name)
              })
              .catch(() => { })
          }
          if (responseData[0].task_coding_user) {
            getUserInfoById(responseData[0].task_coding_user)
              .then((res) => {
                this.makeCopyList.push(res.data)
              })
              .catch(() => { })
          }
          // 所属模块
          getModel(this.editForm.project_id)
            .then((response) => {
              this.modleList = response.data
              this.oldModleList = response.data
              response.data.map((item) => {
                if (item.pm_id === this.editForm.pm_id) {
                  this.$set(this.editForm, 'pm_name', item.pm_name)
                }
              })
            })
            .catch((error) => {
              console.log(error)
            })
          // 相关需求
          getDemand(this.editForm.pm_id)
            .then((response) => {
              this.demandList = response.data.demand
              this.oldDemandList = response.data.demand
              response.data.demand.map((item) => {
                if (this.editForm.demand_id === item.demand_id) {
                  this.$set(this.editForm, 'demand_name', item.demand_name)
                }
              })
            })
            .catch((error) => {
              console.log(error)
            })
        })
        .catch((error) => {
          console.log(error)
        })
    },
    Submit() {
      const params = {
        type: 1, // 类型：0需求，1任务，2缺陷
        id: this.$route.query.task_id, // 需求ID，任务ID，缺陷ID
        remark: this.addRemark.remark, // 内容
        user_id: this.userId // 当前页面登录名
      }
      submitRemark(params)
        .then((response) => {
          this.remarkBtn = false
          this.addRemark.remark = ''
          this.getTasklogList()
        })
        .catch((error) => {
          console.log(error)
        })
    },
    imgTagAddStyle(htmlstr) {
      const regex1 = new RegExp(
        "(i?)(<img)(?!(.*?style=['\"](.*)['\"])[^>]+>)",
        'gmi'
      )
      htmlstr = htmlstr.replace(regex1, '$2 style=""$3')
      const regex2 = new RegExp("(i?)(<img.*?style=['\"])([^>]+>)", 'gmi')
      htmlstr = htmlstr.replace(
        regex2,
        '$2display:block;max-width:100%;height:auto;$3'
      )
      return htmlstr
    },
    // 开发负责人
    getUserInfoByNameCoding(query) {
      if (query) {
        this.selectLoading = true
        const params = {
          name: query,
          pageNum: 1,
          pageSize: 10
        }
        getUserInfoByName(params).then((res) => {
          this.codingProposerList = res.data.list
          this.selectLoading = false
        })
      }
    },
    // 下一处理人
    getUserInfoByNameNext(query) {
      if (query) {
        this.selectLoading = true
        const params = {
          name: query,
          pageNum: 1,
          pageSize: 10
        }
        getUserInfoByName(params).then((res) => {
          this.nextProcessorList = res.data.list
          this.selectLoading = false
        })
      }
    },
    // 测试人   即模糊查询用户
    getUserInfoByNameTest(query) {
      if (query) {
        this.selectLoading = true
        const params = {
          name: query,
          pageNum: 1,
          pageSize: 10
        }
        getUserInfoByName(params).then((res) => {
          this.testList = res.data.list
          this.selectLoading = false
        })
      }
    },
    // 抄送给
    getUserInfoByNameCopy(query) {
      if (query) {
        this.selectLoading = true
        const params = {
          name: query,
          pageNum: 1,
          pageSize: 10
        }
        getUserInfoByName(params).then((res) => {
          this.makeCopyList = res.data.list
          this.selectLoading = false
        })
      }
    },
    // 历史记录
    getTasklogList() {
      const params = {
        task_id: this.$route.query.task_id,
        current: 1
      }
      getTaskLog(params).then((response) => {
        const useridList = []
        for (const i in response.data) {
          useridList.push(response.data[i].dl_creater)
        }
        const p1 = getUserInfoByIdList({
          userIds: useridList
        }).then((res) => {
          const userData = res.data
          for (const i in response.data) {
            for (const j in userData) {
              if (response.data[i].dl_creater === userData[j].userId) {
                response.data[
                  i
                ].dl_creater_name = `${userData[j].name}(${userData[j].username})`
              }
            }
          }
        })
        // console.log("res", useridList);

        Promise.all([p1])
          .then(() => {
            this.historyList = response.data
          })
          .catch(() => {
            this.$message({
              message: '获取用户信息失败!',
              type: 'error'
            })
          })
      })
    },
    // 上传的方法
    tips() {
      this.$message({
        message: '查看状态只能下载！',
        type: 'warning'
      })
    },
    customUpload(file) {
      const _file = file.file
      const isLt10M = _file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('请上传10M以下的文件')
        return false
      }

      uploadImg(file)
        .then((res) => {
          if (res.code === '200') {
            this.successMsg()

            this.editForm.task_attachment.push(res.data)

            const addFileShow = {
              name: res.data,
              url: res.data
            }
            this.fileList.push(addFileShow) // 不添加也可以则不显示绿色打勾（不添加把下面删除移除filelist第i个语句去掉），添加显示绿色打钩
          } else {
            this.$message.error('错了哦，这是一条错误消息')
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    downFile(file) {
      this.$confirm('是否要要下载该文件?', '提示', {
        confirmButtonText: '下载',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const formData = { file_path: file.url }
          axios({
            method: 'post',
            url: `${process.env.VUE_APP_BASE_API}/api/common/download-upload`,
            responseType: 'blob',
            data: formData
          })
            .then((res) => {
              const blobUrl = window.URL.createObjectURL(res.data)
              download(blobUrl)
              function download(blobUrl) {
                const a = document.createElement('a')
                a.style.display = 'none'
                a.download = file.url
                a.href = blobUrl
                a.click()
                document.body.removeChild(a)
              }
            })
            .catch(() => { })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消下载'
          })
        })
    },
    // 上传的结束
    // 成功消息提示
    successMsg() {
      this.$message({
        message: '成功',
        type: 'success'
      })
    },
    decChange(val) {
      this.addRemark.remark = val
    },
    showWorkTimebtn(type, row) {
      if (row.demand_status === 13) return false
      const statusMap = {
        'coderTime': row.task_status !== 7 && row.task_status !== 0,
        'coderEditTime': row.task_status !== 7 && row.task_status !== 0,
        'testTime': [0, 1, 2, 3, 4, 5, 6].includes(row.task_status),
        'testEditTime': [0, 1, 2, 3, 4, 5, 6].includes(row.task_status),
      }
      return statusMap[type]
    },
    formatDemandRemark() {
      const element = document.createElement('div')
      element.innerHTML = this.editForm.demand_remark
      const table = element.querySelectorAll('table')

      for (let i = 0; i < table.length; i++) {
        const widths = []
        const tr = table[i].querySelectorAll('tr')
        const row = tr[1]
        const td = row.querySelectorAll('td')
        const th = row.querySelectorAll('th')
        for (let j = 0; j < td.length; j++) {
          const dataColwidth = td[j].getAttribute('data-colwidth')
          widths.push(dataColwidth ? dataColwidth : td.length > 3 ? '100' : '400')
        }
        for (let j = 0; j < th.length; j++) {
          const dataColwidth = th[j].getAttribute('data-colwidth')
          widths.push(dataColwidth ? dataColwidth : th.length > 3 ? '100' : '400')
        }
        const colgroup = document.createElement('colgroup')
        for (let k = 0; k < widths.length; k++) {
          const col = document.createElement('col')
          col.setAttribute('width', widths[k])
          colgroup.appendChild(col)
        }
        const tableWidth = widths.map(Number).reduce((a, b) => a + b)
        table[i].style.width = tableWidth ? tableWidth + 'px' : '100%'
        table[i].appendChild(colgroup)

        // 表格设置父标签，设置滚动
        const tableParent = document.createElement('div')
        tableParent.classList.add('tiptap-table-wrap')
        const parent = table[i].parentElement
        parent.replaceChild(tableParent, table[i])
        tableParent.append(table[i])
      }
      this.editForm.demand_remark = element.innerHTML
    },
    formatCodeBlock() {
      const element = document.createElement('div')
      element.innerHTML = this.editForm.demand_remark
      const codes = element.querySelectorAll('pre code')
      for (let i = 0; i < codes.length; i++) {
        const code = codes[i]
        code.classList.add('hljs')
        code.classList.add('auto')
      }
      this.editForm.demand_remark = element.innerHTML
      this.$nextTick(() => {
        const codes = document.querySelectorAll('.el-tiptap-editor__content pre code')
        for (let i = 0; i < codes.length; i++) {
          const code = codes[i]
          this.hljs.highlightBlock(code)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.task {
  padding: 0 20px;
}

.content {
  padding: 0 10px 30px;
}

.collapseLabel {
  font-size: 15px;
  font-style: italic;
  font-weight: 600;
}

.header-row {
  font-size: 16px;
  color: #303133;
  font-weight: 600;
  padding: 15px 0;
  border-bottom: 1px solid #ccc;
  margin-bottom: 20px;

  .right span {
    float: right;
  }

  .idBox {
    padding: 3px;
    font-size: 14px;
    border: 1px solid #ccc;
  }

  .roleBtn {
    float: right;
    margin-right: 5px;
  }
}

.left-container {
  .left-item {
    border: 1px solid #cccccc;
    margin-bottom: 20px;
    margin-top: -7px;
    padding: 15px;
  }

  h5 {
    position: absolute;
    background-color: #fff;
    padding: 5px;
    z-index: 999;
    margin: -20px 12px;
  }
}

.right-container {
  padding: 0 0 20px 20px;

  h5 {
    position: absolute;
    background-color: #fff;
    padding: 5px;
    z-index: 999;
    margin: -20px 12px;
  }

  .right-item {
    font-size: 14px;
    color: #666;
    line-height: 25px;
    margin-top: -7px;
    padding: 15px;
    border: 1px solid #cccccc;
    margin-bottom: 20px;

    .demandTitle {

      // overflow: hidden; /*超出部分隐藏*/
      // white-space: nowrap; /*不换行*/
      // text-overflow: ellipsis; /*超出部分省略号显示*/
      .right-item-link {
        margin-bottom: 10px;
      }
    }
  }
}

.historyBox {
  margin-bottom: 15px;

  .label {
    font-size: 15px;
    font-style: italic;
    font-weight: 600;
  }

  .old {
    border: 1px solid #606266;
    border-radius: 5px;
    min-height: 50px;
  }

  .new {
    border: 1px solid green;
    border-radius: 5px;
    min-height: 50px;
  }
}

.left-item {
  word-break: break-all;
  overflow: hidden;
}

.el-tiptap-editor__content {
  max-height: none;
}
.notbug{
    color: #F56C6C;
    font-size: 18px;
    margin-right: 8px;
  }
</style>
